module.exports = __webpack_public_path__ + "2021-05-20T043626520Z/img/dane-vanden-heuvel.c7c8a784.png";